import { Expose } from 'class-transformer';
import { ActionTokenEntity } from './action-token.entity';
import { EmailRequestBaseEntity } from './base.entity';

export class ActionTokenRequestResponse extends EmailRequestBaseEntity {
  @Expose()
  public actionToken: ActionTokenEntity;
}
